export enum ButtonsPagination {
  Zero,
  One,
  Two,
  Three,
  Four,
}
